"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Avatar = _interopRequireDefault(require("@eig-builder/core-ui/Avatar"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 18px;\n  text-transform: uppercase;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: $userInfoColor;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AvatarWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.palette.lightGray.main;
});

var FirstLetter = _styledComponents["default"].span(_templateObject2(), function (props) {
  return props.theme.palette.white.main;
});

var UserAvatar = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(UserAvatar, _Component);

  var _super = _createSuper(UserAvatar);

  function UserAvatar() {
    var _this;

    (0, _classCallCheck2["default"])(this, UserAvatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getInitials = function (name) {
      if (name) {
        var letter = name.charAt(0).toUpperCase();
        return letter;
      }

      return '';
    };

    return _this;
  }

  (0, _createClass2["default"])(UserAvatar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          avatar = _this$props.avatar,
          userFullname = _this$props.userFullname,
          size = _this$props.size,
          firstLetterStyle = _this$props.firstLetterStyle;
      var bigLetter = this.getInitials(userFullname);
      var avatarStyle = {
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: (0, _get["default"])((0, _runtimeConfigHelper.getRuntimeConfig)()._brandVariables, 'defaultUserColor', '#0288D1') // TODO: Runtime 2.0

      }; // assign empty object as first param
      // otherwise customStyle is mutated with the other objects
      // and does not contain the original props

      var style = this.props.customStyle ? Object.assign({}, this.props.customStyle, avatarStyle) : avatarStyle;
      return /*#__PURE__*/_react["default"].createElement(AvatarWrapper, {
        style: style
      }, avatar ? /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        src: avatar,
        size: size,
        style: {}
      }) : /*#__PURE__*/_react["default"].createElement(FirstLetter, {
        style: firstLetterStyle
      }, bigLetter));
    }
  }]);
  return UserAvatar;
}(_react.Component);

UserAvatar.propTypes = {
  userFullname: _propTypes["default"].string,
  size: _propTypes["default"].number,
  avatar: _propTypes["default"].string,
  firstLetterStyle: _propTypes["default"].object,
  customStyle: _propTypes["default"].object
};
UserAvatar.defaultProps = {
  size: 40,
  firstLetterStyle: {
    fontSize: 20
  }
};
var _default = UserAvatar;
exports["default"] = _default;